/** Defines the React context for the user subscription tier. */
// @ts-check
import { createContext } from 'react';

/**
 * @typedef {'free' | 'lite' | 'pro'} UserTier
 */

/**
 * @typedef {Object} TierContextValue
 * @property {UserTier} tier
 * @property {boolean} isFree
 * @property {boolean} isLite
 * @property {boolean} isPro
 * @property {boolean} loading
 * @property {boolean} profileLoaded
 * @property {string[]} seenHints
 * @property {number} loginCount
 * @property {Date | null} createdAt
 * @property {string} profileDisplayName
 * @property {boolean} marketingOptInGranted
 */

/** @type {import('react').Context<TierContextValue | null>} */
export const TierContext = createContext(null);
